var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 135,
    viewBox: "0 0 136 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 135C105.279 135 135.5 104.779 135.5 67.5C135.5 30.2208 105.279 0 68 0C30.7208 0 0.5 30.2208 0.5 67.5C0.5 104.779 30.7208 135 68 135Z",
    fill: "#E54848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0009 84.0022L56.303 25.653C55.6976 12.5521 80.3 12.6324 79.6984 25.653L77.0005 84.0022V88.7426C77.0005 93.693 72.951 97.7424 68.0007 97.7424C63.0503 97.7424 59.0009 93.693 59.0009 88.7426V84.0022Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0008 119.267C72.9616 119.267 76.9831 115.246 76.9831 110.285C76.9831 105.324 72.9616 101.303 68.0008 101.303C63.0401 101.303 59.0186 105.324 59.0186 110.285C59.0186 115.246 63.0401 119.267 68.0008 119.267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3fa5c50309ba49cc141c5f3703192f24.svg";
export { ForwardRef as ReactComponent };